<template>
    <overlay-modal class="without-header" ref="overlayModal" style="z-index: 1040">
        <template>
            <div class="modal-map">
                <div :class=classes>
                    <div>
                        <div class="mb-5">
                            <p class="mb-1 text-uppercase">
                                <b>{{list.length}}</b> attività {{list.length===1? 'trovata' : 'trovate'}}
                            </p>
                            <div>
                                <CustomOrderSelect :list="order" class="lg" @change="onChangeOrder"/>
                            </div>
                        </div>
                        <div class="mb-3 d-flex justify-content-between">
                            <div class="d-flex">
                                <p class="mb-0"><b>Filtra risultati</b><span> | {{counter}}</span></p>
                            </div>
                            <div>
                                <button class="btn btn-sm btn-secondary mr-2" @click="onResetFilter" :disabled="isDisabledReset">reset</button>
                            </div>
                        </div>
                        <div>
                            <DropdownFilterService :is-trasferimento="isTrasferimento" :is-dropdown="false" :list="list" :value="getFilter" />
                        </div>
                    </div>
                    <div :style="`height: ${windowHeight}px;`">
                        <div class="tasks pb-5">
                            <div v-for="(item, index) in listFiltered" :key="index" @mouseover="onMouseHover(item)">
                                <ServicePanel :is-trasferimento="isTrasferimento" :is-from-modal-map="true" :minimize="expanded" :value="item" class="mb-3" :selected="isSelected(item)" @select="onSelectService" @detail="onShowDetail"/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-secondary" @click="onChangeExpand">espandi mappa</button>
                        <GmapMap ref="mapRef" :options="{
                           zoomControl: true,
                           mapTypeControl: false,
                           scaleControl: true,
                           streetViewControl: false,
                           rotateControl: false,
                           fullscreenControl: false,
                           disableDefaultUi: false}" :center="center" :zoom="zoom" map-type-id="terrain" class="map">
                            <gmap-custom-marker :offsetY="-10" :key="index" v-for="(m, index) in markers" :z-index="m.zIndex" @click.native="onSelectMarker(m)" :marker="m" alignment="top">
                                <CustomServiceMarker :value="m" :hover="selectedItem" />
                            </gmap-custom-marker>
                        </GmapMap>
                    </div>
                </div>
            </div>
            <div>
                <ModalServiceDetail v-if="selectedItem" :is-trasferimento="isTrasferimento" ref="modalServiceDetail" :value="selectedItem" @change="onChangeServiceGroup" />
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { vueWindowSizeMixin } from 'vue-window-size'
import OverlayModal from '../../../modals/OverlayModal'
import TimeRangeSlider from '../TimeRangeSlider'
import ServicePanel from '../ServicePanel'
import CustomOrderSelect from '../CustomOrderSelect'
import ShowMore from '../ShowMore'
import {LATITUDE, LONGITUDE} from '../../../../utils/config'
import DropdownFilterService from '../dropdown/DropdownFilterService'
import {defaultFiltererServizi, defaultSortererServizi} from '../../../../utils/serviziUtils'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import CustomServiceMarker from '../google-map/CustomServiceMarker'
import ModalServiceDetail from '../../common/modals/ModalServiceDetail'
import AnalyticEvents from '../../../common/AnalyticEvents'

const DEFAULT_BOUND_ZOOM = 12
const DEFAULT_ZOOM = 11

export default {
  mixins: [vueWindowSizeMixin, AnalyticEvents],
  name: 'ModalServicesMap',
  components: {ModalServiceDetail, CustomServiceMarker, GmapCustomMarker, DropdownFilterService, ShowMore, CustomOrderSelect, ServicePanel, TimeRangeSlider, OverlayModal},
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isTrasferimento: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selectedItem: this.list[0],
      expanded: false,
      openOrder: false,
      showAll: false,
      center: {lat: LATITUDE, lng: LONGITUDE},
      zoom: DEFAULT_BOUND_ZOOM,
      order: [
        {name: 'prezzo', dir: 'up'},
        {name: 'prezzo', dir: 'down'}
      ]
    }
  },
  computed: {
    classes () {
      return this.expanded ? 'expanded d-flex justify-content-around' : 'd-flex justify-content-around'
    },
    counter () {
      return this.listFiltered.length
    },
    getFilter () {
      return this.isTrasferimento ? this.getTrasferimentiFilter() : this.getServiziFilter()
    },
    isDisabledReset () {
      return Object.values(this.getFilter).every(x => x == null)
    },
    getOrder () {
      return this.isTrasferimento ? this.getTrasferimentiOrder() : this.getServiziOrder()
    },
    listFiltered () {
      const list = this.list.filter(this.filterer).sort(this.sorterer)
      const listDaSpingere = list.filter(item => item.config && item.config.isDaSpingere)
      return listDaSpingere.concat(list.filter(item => !(item.config && item.config.isDaSpingere)))
    },
    markers () {
      const list = this.listFiltered
      const listToReturn = list.filter(item => item.anagrafica.element.places[0] && item.anagrafica.element.places[0].coordinate).map((item) => {
        const firstDayPrice = item.pricesByDay[0].prices.map(item => item.venditaTotaleEuro).reduce((t, c) => t + c)
        const selected = this.isSelected(item)
        const zIndex = selected ? 1 : -1
        const firstPlace = item.anagrafica.element.places[0]
        if (firstPlace && firstPlace.coordinate) {
          const {latitude, longitude} = firstPlace.coordinate
          return {name: item.anagrafica.element.name, lat: latitude, lng: longitude, selected, price: firstDayPrice, item, zIndex, hover: false}
        }
      })
      return listToReturn
    }
  },
  methods: {
    ...mapGetters(['getTrasferimentiFilter', 'getServiziFilter', 'getTrasferimentiOrder', 'getServiziOrder', 'resetTrasferimentoFilter', 'resetServiziFilter', 'getServiziSelected', 'getTrasferimentiSelected', 'getListaServizi', 'getListaTrasferimenti']),
    ...mapActions(['addReplaceServizio', 'modifyServiziFilter', 'resetServiziFilter', 'modifyTrasferimentoFilter', 'resetTrasferimentoFilter', 'modifyServiziOrder', 'modifyTrasferimentoOrder']),
    open: function () {
      this.zoom = DEFAULT_BOUND_ZOOM
      const coords = this.markers.map(item => {
        return {lat: item.lat, lng: item.lng}
      })
      this.$refs.mapRef.$mapPromise.then((map) => {
        const bounds = new window.google.maps.LatLngBounds()
        coords.forEach(c => {
          bounds.extend(c)
        })
        map.panToBounds(bounds)
      })
      this.$refs.overlayModal.open()
    },
    close: function () {
      this.$refs.overlayModal.close()
    },
    onChangeExpand: function () {
      this.expanded = !this.expanded
    },
    onResetFilter: function () {
      if (this.isTrasferimento) {
        this.resetTrasferimentoFilter()
      } else {
        this.resetServiziFilter()
      }
    },
    onOpenOrder: function () {
      this.openOrder = !this.openOrder
    },
    onClickMarker: function (marker) {
      this.center = marker.position
    },
    onSelectService () {
      // perchè si chiuda deve selezionare almeno l'andata ed il ritorno
      // if (this.isTrasferimento && this.getTrasferimentiSelected().length < 2) {
      //   return
      // }
      // this.close()
    },
    onShowDetail (item) {
      this.selectedItem = null
      this.$nextTick(() => {
        this.selectedItem = item
        this.$nextTick(() => {
          this.$refs.modalServiceDetail.open(item.groups)
        })
      })
    },
    isSelected (servizio) {
      const list = this.isTrasferimento ? this.getTrasferimentiSelected() : this.getServiziSelected()
      return list.some(item => {
        return servizio.detail.productID === item.detail.productID
      })
    },
    onMouseHover (item) {
      if (this.selectedItem !== item) {
        this.selectedItem = item
        this.markers.forEach(marker => {
          if (marker.item.detail.productID === this.selectedItem.detail.productID) {
            marker.hover = true
            marker.zIndex = 3
          } else {
            marker.zIndex = -1
          }
        })
        const firstPlace = this.selectedItem.anagrafica.element.places[0]
        if (firstPlace && firstPlace.coordinate) {
          const {latitude, longitude} = firstPlace.coordinate
          this.$refs.mapRef.$mapPromise.then((map) => {
            this.zoom = DEFAULT_ZOOM
            map.panTo({lat: latitude, lng: longitude})
          })
        }
      }
    },
    onSelectMarker (marker) {
      this.onShowDetail(marker.item)
    },
    filterer (item) {
      return defaultFiltererServizi(item, this.getFilter)
    },
    sorterer (a, b) {
      return defaultSortererServizi(a, b, this.getOrder)
    },
    onChangeOrder: function (order) {
      if (this.isTrasferimento) {
        this.modifyTrasferimentoOrder({prezzo: order.dir})
      } else {
        this.modifyServiziOrder({prezzo: order.dir})
      }
    },
    onChangeServiceGroup (groups) {
      this.close()
      this.groupsSelected = groups
      const payload = {...this.selectedItem, groups: [...this.groupsSelected]}
      this.addReplaceServizio(payload)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/modals/ModalServicesMap.vue